import styled from "styled-components";
import { ReactComponent as IconArrow } from "../../../styles/assets/svg/icon_backArrow.svg";
import { ReactComponent as IconSetting } from "../../../styles/assets/svg/icon_setting.svg";
import { titleText } from "../MainHeaderBox/MainConHeader";

interface conSubHeaderProps {
  title: string;
  onClickArrow?: () => void;
  onClickSetting?: () => void;
  setBackIcon?: boolean;
  setIcon?: boolean;
  $bgColor?: string;
}

interface styleProps {
  $bgColor?: string;
}

const SubHeaderBox = styled.div<styleProps>`
  /* width: 100vw; */
  max-width: 45rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
  margin: 0 -16px;
  background-color: ${(props) => (props.$bgColor ? props.$bgColor : "#F7F7F7")};
  box-sizing: border-box;

  svg {
    cursor: pointer;
  }

  path {
    stroke: #000;
  }
`;

export const SubConHeader = ({
  title,
  onClickArrow,
  onClickSetting,
  setBackIcon,
  setIcon,
  $bgColor,
}: conSubHeaderProps) => {
  return (
    <SubHeaderBox $bgColor={$bgColor}>
      {setBackIcon ? (
        <div style={{ width: 24, height: 24 }} />
      ) : (
        <IconArrow onClick={onClickArrow} style={{ cursor: "pointer" }} />
      )}
      <div style={{ ...titleText, color: "#000000" }}>{title}</div>
      {setIcon ? (
        <IconSetting onClick={onClickSetting} style={{ cursor: "pointer" }} />
      ) : (
        <div style={{ width: 24, height: 24 }} />
      )}
    </SubHeaderBox>
  );
};
